export const NotificationType = {
  FEEDBACK_STATUS_CHANGED: "feedback_status_changed",
  FEEDBACK_COMMENT_ADDED: "feedback_comment_added",
  MEETING_REMINDER: "meeting_reminder",
  MEETING_SCHEDULED: "meeting_scheduled",
  CANDIDATE_STATUS_CHANGED: "candidate_status_changed",
  PROJECT_UPDATE: "project_update",
  SYSTEM_ANNOUNCEMENT: "system_announcement",
} as const;

export type NotificationType =
  (typeof NotificationType)[keyof typeof NotificationType];

export const NotificationPriority = {
  LOW: "low",
  NORMAL: "normal",
  HIGH: "high",
} as const;

export type NotificationPriority =
  (typeof NotificationPriority)[keyof typeof NotificationPriority];

export interface Notification {
  id: string;
  user_id: string;
  type: NotificationType;
  title: string;
  body: string;
  priority: NotificationPriority;
  is_read: boolean;
  read_at: string | null;
  action_url: string | null;
  source_type: string | null;
  source_id: string | null;
  metadata: Record<string, unknown> | null;
  createdAt: string;
  updatedAt: string;
}

export interface NotificationListResponse {
  items: Notification[];
  total: number;
  page: number;
  limit: number;
  unread_count: number;
}

export interface UnreadCountResponse {
  unread_count: number;
}
